import { useSelector } from "react-redux";
import { selectCurrentLogbook } from "../../store/features/logbooks.slice";
import EditLogbook from "../common/edit-logbook";

export default function EditOwnerLogbook() {
  const logbook = useSelector(selectCurrentLogbook);

  return <EditLogbook logbook={logbook} />;
}
